import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface AdminUser {
    id: number;
    email: string;
    roles: string[];
    verified: boolean;
    creditBalance: number;
    createdAt: string;
    deletionRequestedAt: string | null;
    lastLoginAt: string | null;
    passwordChangedAt: string | null;
    passkeysCount: number;
    failedLoginAttempts: number;
    hasActivePasswordResetToken: boolean;
}

export interface AdminUserListResponse {
    users: AdminUser[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export function useAdminUsers(page = 1, limit = 20, emailSearch?: string) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    if (emailSearch) {
        params.set('email', emailSearch);
    }

    return useQuery<AdminUserListResponse>({
        queryKey: ['admin', 'users', page, limit, emailSearch],
        queryFn: () => api.get(`/api/admin/users?${params}`),
    });
}
